/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { mediaFilesActions } from './mediaSlice';

export const changeMediaView = (view) => async (dispatch) => {
  return await dispatch(mediaFilesActions.mediaFilesView(view));
};
